import React, { useEffect } from 'react';
import {BrowserRouter as Router,Route,Switch } from 'react-router-dom';
import Home from './app/components/home';
import TermsAndConditions from './app/components/terms';
import RefundPolicy from './app/components/refund';
import PrivacyPolicy from './app/components/privacy';
import ReactGA from 'react-ga';


function App() {
  useEffect(() => {
    ReactGA.initialize('G-6ZD5XZV4R0');
  },[]);
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/terms" component={TermsAndConditions}/>
          <Route exact path="/refund-policy" component={RefundPolicy}/>
          <Route exact path="/privacy-policy" component={PrivacyPolicy}/>
          <Route component={Home}/>
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
